module.exports = __webpack_public_path__ + "static/media/ios.040c073a.png";